<template>
  <div class="">
    <img class="relative w-full h-full object-fill" src="@/assets/images/menon.svg" />
  </div>
</template>

<script lang="ts" setup></script>
